var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkOutlined2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.791504 9.49996C0.791504 14.3094 4.69036 18.2083 9.49984 18.2083C14.3093 18.2083 18.2082 14.3094 18.2082 9.49996C18.2082 4.69048 14.3093 0.791626 9.49984 0.791626C4.69036 0.791626 0.791504 4.69048 0.791504 9.49996ZM16.6248 9.49996C16.6248 13.435 13.4349 16.625 9.49984 16.625C5.56481 16.625 2.37484 13.435 2.37484 9.49996C2.37484 5.56493 5.56481 2.37496 9.49984 2.37496C13.4349 2.37496 16.6248 5.56493 16.6248 9.49996ZM9.5001 13.457C9.93747 13.457 10.292 13.1025 10.292 12.6653C10.292 12.2281 9.93747 11.8737 9.5001 11.8737C9.06273 11.8737 8.70817 12.2281 8.70817 12.6653C8.70817 13.1025 9.06273 13.457 9.5001 13.457ZM8.70817 11.0833H10.2915C10.2915 10.4513 10.3908 10.3354 11.0414 10.0101C12.172 9.4448 12.6665 8.86793 12.6665 7.52079C12.6665 5.79546 11.3083 4.74996 9.49984 4.74996C7.75094 4.74996 6.33317 6.16772 6.33317 7.91663H7.9165C7.9165 7.04218 8.62539 6.33329 9.49984 6.33329C10.5109 6.33329 11.0832 6.77378 11.0832 7.52079C11.0832 8.15282 10.9839 8.26866 10.3333 8.59395C9.20263 9.15929 8.70817 9.73616 8.70817 11.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkOutlined2);
export default __webpack_public_path__ + "static/media/question-mark-outlined-2.fa835b08.svg";
export { ForwardRef as ReactComponent };